module.exports = __webpack_public_path__ + "img/logo.0f6b5719.png";